'use strict';
var $ = require('../internals/export');
var trunc = require('../internals/math-trunc');

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: trunc
});



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/es.math.trunc.js
// module id = 1025
// module chunks = 0